<template>
  <v-row class="my-3 bg-EDF8F7" :class="phone || tablet ? '' : 'mx-10'">
    <v-col cols="12" class="d-flex">
      <v-row>
        <v-col cols="auto" align-self="center">
          <v-avatar tile size="28" color="#EDF8F7" class="mr-2">
            <v-img src="@/assets/icon/document.svg" /> </v-avatar
          >
        </v-col>
        <v-col cols="auto" align-self="center" class="px-0">
          <span class="w-700">{{ hos_name }}</span>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" class="pt-3" :class="phone || tablet ? '' : 'px-16'">
      <v-row :class="phone ? '' : 'pl-4'">
        <v-col cols="12" lg="4" md="4" sm="6">
          <v-row>
            <v-col cols="auto" align-self="center">
              <span>ชื่อ-นามสกุล :</span>
            </v-col>
            <v-col cols="auto" align-self="center" class="px-0">
              <span class="w-600">{{ general_info.fullname || '-' }}</span>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" lg="4" md="4" sm="6">
          <v-row>
            <v-col cols="auto" align-self="center">
              <span>วัน/เดือน/ปีเกิด :</span>
            </v-col>
            <v-col cols="auto" align-self="center" class="px-0">
              <span class="w-600">{{ formatBirthDate(general_info.birth_date) || '-' }}</span>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" lg="4" md="4" sm="6">
          <v-row>
            <v-col cols="auto" align-self="center">
              <span>อายุ :</span>
            </v-col>
            <v-col cols="auto" align-self="center" class="px-0">
              <span class="w-600">{{ calculateAge(general_info.birth_date) || '-' }}</span>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" class="pt-3" :class="phone || tablet ? '' : 'px-16'">
      <v-row :class="phone ? '' : 'pl-4'">
        <v-col cols="12" lg="4" md="4" sm="6">
          <v-row>
            <v-col cols="auto" align-self="center">
              <span>เลขประจำตัวประชาชน :</span>
            </v-col>
            <v-col cols="auto" align-self="center" class="px-0">
              <span class="w-600">{{ id(general_info.cid) || '-' }}</span>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" lg="4" md="4" sm="6">
          <v-row>
            <v-col cols="auto" align-self="center">
              <span>เพศ :</span>
            </v-col>
            <v-col cols="auto" align-self="center" class="px-0">
              <span class="w-600">{{ general_info.gender || '-' }}</span>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" lg="4" md="4" sm="6">
          <v-row>
            <v-col cols="auto" align-self="center">
              <span>เบอร์โทรศัพท์ :</span>
            </v-col>
            <v-col cols="auto" align-self="center" class="px-0">
              <span class="w-600">{{ mobile(general_info.mobile) || '-' }}</span>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import moment from "moment";
import functioncryto from "@/services/encrypt.js";

export default {
  props: ['general_info'],
  data() {
    return {
      hos_name: sessionStorage.getItem('biz_name')
    }
  },
  computed: {
    x_mobile: {
      get: function () {
        if (this.$vuetify.breakpoint.width <= 820) {
          return true;
        } else {
          return false;
        }
      },
      set: function (newValue) {
        this.nav = newValue;
      }
    },
    phone() {
      if (this.$vuetify.breakpoint.width < 450) {
        return true;
      } else {
        return false;
      }
    },
    tablet() {
      if (this.$vuetify.breakpoint.width <= 820) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    formatBirthDate(x) {
      if(x != '' && x != null && x != undefined) {
        var year1 = "";
        var year2 = "";
        year1 = moment(x).locale("th").format("YYYY");
        year2 = (parseInt(year1) + 543).toString();
        return moment(x)
          .locale("th")
          .format("DD MMMM " + year2);
      } else {
        return ''
      }
    },
    calculateAge(date) {
      if (date !== '' && date !== null && date !== undefined) {
        const y = Math.floor(moment.duration(moment().diff(date)).asYears());
        return y.toString() + ' ปี'
      } else {
        return '-'
      }
    },
    id(id) {
      if (functioncryto.decrypt(id) == undefined || functioncryto.decrypt(id) == '' || functioncryto.decrypt(id) == null) {
        return "-";
      } else {
        // var maskedDigits = "X".repeat(6);
        // var visibleDigits = functioncryto.decrypt(id).substring(6);
        // var cid = maskedDigits + visibleDigits;
        var cid = id

        return (
          functioncryto.decrypt(cid).substring(0, 1) +
          "-" +
          functioncryto.decrypt(cid).substring(1, 5) +
          "-" +
          functioncryto.decrypt(cid).substring(5, 10) +
          "-" +
          functioncryto.decrypt(cid).substring(10, 12) +
          "-" +
          functioncryto.decrypt(cid).substring(12, 13)
        );
      }
    },
    mobile(mobile) {
      if (mobile == undefined || mobile == "" || mobile == null) {
        return "-";
      } else if (mobile.length == 10) {
        return (
          mobile.substring(0, 3) +
          "-" +
          mobile.substring(3, 6) +
          "-" +
          mobile.substring(6, 10)
        )
      } else if (mobile.length == 9) {
        return (
          mobile.substring(0, 3) +
          "-" +
          mobile.substring(3, 6) +
          "-" +
          mobile.substring(6, 9)
        );
      } else return mobile;
    },
  }
}
</script>

<style>

</style>